import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Box, Flex } from '@qga/roo-ui/components';
import isBlackouted from '@/utils/isBlackouted';
import useCampaign from '@/hooks/useCampaign';
import useDestination from '@/hooks/useDestination';
import DateRange from '../../../DateRange';
import DepartingFrom from '../DepartingFrom';
import useProcuredOffer from '../../../PackagePage/hooks/useProcuredOffer/useProcuredOffer';
import { useDestination as v2UseDestination } from '@/v2/contexts/destination';
import { useCampaign as v2UseCampaign } from '@/v2/contexts/campaign';

const DepartingFromAndDateRange = React.memo(
  ({
    originCode: initialOriginCode,
    departureDate: initialDepartureDate,
    returnDate: initialReturnDate,
    onChangeRoute,
    onChangeDateRange,
    error,
    onCalendarFocus,
    calendarFocused,
  }) => {
    const d = useDestination();
    const dV2 = v2UseDestination();

    const destination = d || dV2;

    const c = useCampaign();
    const cv2 = v2UseCampaign();
    const campaign = c || cv2;

    const procuredOffer = useProcuredOffer();

    const [originCode, setOriginCode] = useState(initialOriginCode);
    useEffect(() => {
      setOriginCode(initialOriginCode);
    }, [initialOriginCode]);

    const [departureDate, setDepartureDate] = useState(initialDepartureDate);
    useEffect(() => {
      setDepartureDate(initialDepartureDate);
    }, [initialDepartureDate]);

    const [returnDate, setReturnDate] = useState(initialReturnDate);
    useEffect(() => {
      setReturnDate(initialReturnDate);
    }, [initialReturnDate]);
    return (
      <>
        <Flex flexDirection={['column', null, 'row']} flex="1">
          <Box flex="1">
            <DepartingFrom
              originCodes={destination.searchConfig.originCodes}
              value={originCode}
              error={error}
              calendarFocused={calendarFocused}
              onSubmit={(value) => {
                setOriginCode(value);
                const blackoutDates = destination.blackoutDates[value];
                if (
                  blackoutDates &&
                  isBlackouted(blackoutDates, { departureDate, returnDate })
                ) {
                  setDepartureDate();
                  setReturnDate();
                  onChangeRoute({
                    destination,
                    origin: { code: value },
                    departureDate: undefined,
                    returnDate: undefined,
                  });
                  return;
                }
                onChangeRoute({
                  destination,
                  origin: { code: value },
                });
              }}
            />
          </Box>
          <Box m={2} />
          <Box flex="1">
            <DateRange
              initialDates={{ departureDate, returnDate }}
              originCode={originCode}
              destinationCode={destination.searchConfig.destinationCode}
              onDataChange={onChangeDateRange}
              blackoutDates={destination.blackoutDates[originCode]}
              minimumNights={destination.searchConfig.minimumNights}
              campaign={campaign}
              error={error}
              isProcuredOffer={!!procuredOffer}
              onCalendarFocus={onCalendarFocus}
            />{' '}
          </Box>
        </Flex>
      </>
    );
  },
);

DepartingFromAndDateRange.defaultProps = {
  originCode: undefined,
  departureDate: undefined,
  returnDate: undefined,
};

DepartingFromAndDateRange.propTypes = {
  originCode: PropTypes.string,
  departureDate: PropTypes.string,
  returnDate: PropTypes.string,
  onChangeRoute: PropTypes.func.isRequired,
  onChangeDateRange: PropTypes.func.isRequired,
  error: PropTypes.shape({
    origin: PropTypes.string,
    destination: PropTypes.string,
    departureDate: PropTypes.string,
    returnDate: PropTypes.string,
    route: PropTypes.string,
  }).isRequired,
};

export default DepartingFromAndDateRange;
